import React from "react"
import "./TopAppCardM.css"
import "./TopAppCardSkeleton.css"

const Bone = ({ className, style }) => <div className={`kq-skel-bone ${className || ""}`} style={style} />

const TopAppCardSkeleton = () => (
  <div className="app-card-container2" style={{ border: "none", background: "transparent" }}>
    <div className="p-0">
      <div className="p-lg-4 p-2">
        <div className="kq-app-card kq-app-card--skeleton">
          <div className="kq-app-card__top">
            <div className="kq-app-card__icon-wrap">
              <Bone className="kq-skel-bone--icon" />
            </div>

            <div className="kq-app-card__info">
              <Bone className="kq-skel-bone--title" />
              <Bone className="kq-skel-bone--meta" />
              <Bone className="kq-skel-bone--platform" />
            </div>

            <div className="kq-app-card__price">
              <Bone className="kq-skel-bone--price-label" />
              <Bone className="kq-skel-bone--price-value" />
            </div>
          </div>

          <div className="kq-app-card__stats">
            <div className="kq-app-card__stat">
              <Bone className="kq-skel-bone--stat-label" />
              <Bone className="kq-skel-bone--stat-value" />
            </div>
            <div className="kq-app-card__stat">
              <Bone className="kq-skel-bone--stat-label" />
              <Bone className="kq-skel-bone--stat-value" />
            </div>
            <div className="kq-app-card__stat">
              <Bone className="kq-skel-bone--stat-label" />
              <Bone className="kq-skel-bone--stat-value" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default TopAppCardSkeleton
